import React from "react";
import { ChevronsRight, FileText, PlusCircle, Users } from "react-feather";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { UserLevel } from "utils/constant";

const SidebarBKK = () => {
  const { currentUser } = useSelector((state) => state.authReducer);

  return (
    <>
      {/* Data Dasar BKK */}
      {currentUser.level === UserLevel.BKKWilker && (
        <li className="nav-item">
          <Link to="/data-dasar-bkk">
            <Users size={18} className="mr-2" />
            <p>Data Dasar BKK</p>
          </Link>
        </li>
      )}
      {/* Data Dasar BKK Wilker */}
      {currentUser.level === UserLevel.BKKInduk && (
        <li className="nav-item">
          <Link to="/data-dasar-bkk-wilker">
            <Users size={18} className="mr-2" />
            <p>Data Dasar BKK Wilker</p>
          </Link>
        </li>
      )}
      {/* Data Kasus BKK */}
      <li className="nav-item">
        <a data-toggle="collapse" href="#master">
          <PlusCircle size={18} className="mr-2" />
          <p>Data Kasus</p>
          <span className="caret" />
        </a>
        <div className="collapse" id="master">
          <ul className="nav nav-collapse">
            <li>
              <Link to="/register-malaria-1-bkk">
                <ChevronsRight className="icon-menu" />
                <span className="sub-item">Register Malaria 1</span>
              </Link>
            </li>
            <li>
              <Link to="/regmal-dua-bkk">
                <ChevronsRight className="icon-menu" />
                <span className="sub-item">Register Malaria 2</span>
              </Link>
            </li>
            <li>
              <Link to="/notifikasi-kasus-bkk">
                <ChevronsRight className="icon-menu" />
                <span className="sub-item">Notifikasi Kasus BKK</span>
              </Link>
            </li>
            <li>
              <Link to="/notifikasi-pe-feedback-bkk">
                <ChevronsRight className="icon-menu" />
                <span className="sub-item">Notifikasi PE Feedback</span>
              </Link>
            </li>
          </ul>
        </div>
      </li>
      {/* Zero Report */}
      <li className="nav-item">
        <Link to="/zero-report-bkk">
          <FileText size={18} className="mr-2" />
          <p>Zero Report BKK</p>
        </Link>
      </li>
      {/* Data Dasar Lab */}
      <li className="nav-item">
        <Link to="/data-dasar-lab-bkk">
          <FileText size={18} className="mr-2" />
          <p>Data Dasar Laboratorium BKK</p>
        </Link>
      </li>
      {/* Data Mikroskopis BKK */}
      <li className="nav-item">
        <Link to="/mikroskopis-bkk">
          <FileText size={18} className="mr-2" />
          <p>Data Mikroskopis BKK</p>
        </Link>
      </li>
    </>
  );
};

export default SidebarBKK;
